/* Publish by EComposer at 2026-10-21 02:10:50*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7rc6z7eisnm"]=  window.__ectimmers["ecom-7rc6z7eisnm"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-7rc6z7eisnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7rc6z7eisnm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9b4ln6zcum').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9b4ln6zcum', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hy2izfeah6t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hy2izfeah6t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nqag5fzh26c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nqag5fzh26c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yifrxnfe6ad').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yifrxnfe6ad', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vnuy8vgwcqr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vnuy8vgwcqr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-da0bm92ezlq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-da0bm92ezlq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mmlud47r9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mmlud47r9j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-asrxac938gn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-asrxac938gn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f8tqgj42tik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f8tqgj42tik', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gie4ts2raxp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gie4ts2raxp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bvmvfgrasde').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bvmvfgrasde', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-27j7es60pi9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-27j7es60pi9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j0x95lov2h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j0x95lov2h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u13offchuib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u13offchuib', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6btxf0aherl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6btxf0aherl', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ductefsm3y5"]=  window.__ectimmers["ecom-ductefsm3y5"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-ductefsm3y5"]["hitt24gwb"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ductefsm3y5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ductefsm3y5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n4zua88k3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n4zua88k3c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-20484w0szvn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20484w0szvn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1xxt3r71twbi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1xxt3r71twbi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gm310n24y1c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gm310n24y1c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rpw28pi96tc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rpw28pi96tc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yhmlgd21sx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yhmlgd21sx', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-emqv1y3bb29"]=  window.__ectimmers["ecom-emqv1y3bb29"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-emqv1y3bb29"]["ldv33ia1q"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-emqv1y3bb29').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-emqv1y3bb29', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y8rl75aqanp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y8rl75aqanp', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8c9ieo1tjhp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8c9ieo1tjhp', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dqvytcneiqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dqvytcneiqn', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q5ubrhm6qxn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q5ubrhm6qxn', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cdmmb73axrl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cdmmb73axrl', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wn1bh30mm6r"]=  window.__ectimmers["ecom-wn1bh30mm6r"] || {};
const t=this.$el;if(!t)return;let e=this.isLive,i=t.querySelector(".ecom-masonry-layout");if(!i)return;if(this.settings.lightbox){let a=this.$el.querySelectorAll("[ecom-modal]");a.forEach(d=>{let p=d.closest("a[href]");p&&p.addEventListener("click",function(m){e||m.preventDefault(),m.stopPropagation()},!0)});const l=function(d){if(window.EComModal)return d();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&d()});return}let p=0;const m= window.__ectimmers["ecom-wn1bh30mm6r"]["ve4axt3xd"] = setInterval(function(){window.EComModal?(clearInterval(m),d()):++p>=300&&clearInterval(m)},50)},c=()=>{a.length&&window.EComModal&&new window.EComModal(a,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})};a.length&&l(c)}i.addEventListener("itemChange",function(){setTimeout(function(){i.masonry.layout()},500)});var o=i.getAttribute("data-ecom-packery-params")||"{}";let n=Object.assign({itemSelector:".ecom-masonry-layout__item",layoutMode:"masonry",percentPosition:!0,resize:!0},JSON.parse(o));var r=new window.EComPackery(i,n);i.masonry=r,i.querySelectorAll("img").forEach(function(a){a.addEventListener("load",function(){r.layout()})})

                    });
                    
                        document.querySelectorAll('.ecom-wn1bh30mm6r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wn1bh30mm6r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jfnnuipdk3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jfnnuipdk3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-umet3k67b4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-umet3k67b4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5febqrc1vt7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5febqrc1vt7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rd7wf213gxn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rd7wf213gxn', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}